/** Entrada única por navegador; retornos não renovam a janela do público. */
export const INICIO_REMARKETING = Date.parse("2026-09-09T00:00:00-03:00");
export const EVENTO_ENTRADA_REMARKETING = "remarketing_entry_20260909";
const CHAVE = "ida.remarketing.entrada.20260909";

type Plataforma = "meta" | "google" | "posthog";
export function registrarEntradaRemarketing({ agora, primeiroAcesso, plataforma, storage, enviar }: {
  agora: number;
  primeiroAcesso: string | undefined;
  plataforma: Plataforma;
  storage: Pick<Storage, "getItem" | "setItem">;
  enviar: () => void;
}): void {
  if (agora < INICIO_REMARKETING || !primeiroAcesso) return;
  const primeiraVisita = Date.parse(primeiroAcesso);
  if (!Number.isFinite(primeiraVisita) || primeiraVisita < INICIO_REMARKETING || primeiraVisita > agora) return;
  try {
    const anterior = storage.getItem(CHAVE);
    const estado = anterior ? JSON.parse(anterior) : { entrada: primeiraVisita };
    if (!Number.isFinite(estado.entrada) || estado.entrada < INICIO_REMARKETING
      || agora >= estado.entrada + 14 * 86400000 || estado[plataforma]) return;
    // Persiste antes de enfileirar: falha no armazenamento não pode renovar o público.
    storage.setItem(CHAVE, JSON.stringify({ ...estado, [plataforma]: true }));
    enviar();
  } catch { /* Sem persistência confiável, não inclui este navegador no público. */ }
}
